import { ContentEmpty } from '@/components/ContentLayout'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type ProfilePayoutMethodViewModel } from '@/features/payouts/pro/ProfilePayoutMethodViewModel'
import { PayoutMethodsEmptyState } from '@/features/billing/components/PayoutMethodsEmptyState'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { ProfilePayoutMethod } from '@/features/payouts/pro/components/ProfilePayoutMethod'

export interface ProfilePayoutMethodContainerProps {
  vm: ProfilePayoutMethodViewModel
}

export const ProfilePayoutMethodContainer = observer(
  function ProfilePayoutMethodContainer({
    vm,
  }: ProfilePayoutMethodContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return vm.fetch.match({
      pending: () => <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () =>
        !vm.payoutMethod ? (
          <ContentEmpty>
            <PayoutMethodsEmptyState
              canAddPayoutMethod={true}
              isAddPending={vm.addPayoutMethod.pending}
              onNewPayoutMethod={vm.addPayoutMethod}
              corporateMode={shellInfo.corporateMode}
            />
          </ContentEmpty>
        ) : (
          <ProfilePayoutMethod
            type={vm.payoutMethod.type}
            stripeAccountId={vm.payoutMethod.stripeAccountId}
            onReplace={vm.addPayoutMethod}
          />
        ),
    })
  },
)
